import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getCurrentOrganisationInsightSets(organisationId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/insightsets';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        isAllocatedTo,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const insightSets = response.data.insightSets;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_ORG_ALLOCATED_INSIGHTSETS' : 'UPDATE_CURRENT_ORG_UNALLOCATED_INSIGHTSETS';
        dispatch({ type, insightSets });
      },
     error => dispatch(APIError(error, 'Error getting currentOrganisation insightSets'))
    );
  };
}

export function addInsightSetToCurrentOrganisation(insightSetId, organisationId) {
  return function(dispatch, getState) {
    const endpoint = '/insightset/membership/organisation';
    const options = {
      method: "POST",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        insightSetId,
        organisationId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCurrentOrganisationInsightSets(organisationId, true));
        dispatch(getCurrentOrganisationInsightSets(organisationId, false));
        return response;
      },
     error => dispatch(APIError(error, 'Error adding insightSet to currentOrganisation'))
    );
  }
}

export function removeInsightSetFromCurrentOrganisation(insightSet, organisationId) {
  return function(dispatch, getState) {
    const endpoint = `/insightset/membership/organisation/${insightSet.membershipId}`;
    const options = {
      method: "PUT",
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCurrentOrganisationInsightSets(organisationId, true));
        dispatch(getCurrentOrganisationInsightSets(organisationId, false));
        return response;
      },
     error => dispatch(APIError(error, 'Error removing insightSet from currentOrganisation'))
    );
  }
}



// WEBPACK FOOTER //
// ./src/actions/organisations/insightSetCreators.js